import React from 'react';

export default function NoData() {
  return (
    <div className="py-5 border-bottom w-100 text-center">
      <h2>No payments to show</h2>

      <div className="mb-4">There are no payments to show this time</div>
    </div>
  );
}
